/* eslint-disable */
import GoEasy from "goeasy";
import { getUserInfo, isMobilePage } from "@/views/goEasy/sdk/utils.js";
import axios from "axios";
import { ElMessage, ElNotification, ElButton } from "element-plus";
import emitter from "@/utils/emitter";
import router from "@/router";
import { h } from "vue";
import "@/views/goEasy/assets/style/grtcNotification.css";

// 已订阅的频道缓存
const subscribedChannels = new Set();

/**
 * 检查频道是否已订阅
 */
function isChannelSubscribed(channel) {
	console.log(14, "isChannelSubscribed", channel, subscribedChannels.has(channel))
	return subscribedChannels.has(channel);
}

/**
 * 标记频道已订阅
 */
function markChannelSubscribed(channel) {
	subscribedChannels.add(channel);
}

/**
 * 通用订阅函数
 * @param {string} channel 频道名称
 * @param {Function} onMessage 消息回调
 * @param {string} logPrefix 日志前缀
 */
function doSubscribe(channel, onMessage, logPrefix) {
	if (isChannelSubscribed(channel)) {
		// console.log(`${logPrefix} already subscribed, skip.`);
		return;
	}
	markChannelSubscribed(channel);
	GoEasy.pubsub.subscribe({
		channel,
		onMessage,
		onSuccess: function () {
			console.log(`${logPrefix} ${channel} subscribe successfully.`);
		},
		onFailed: function (error) {
			console.error(`${logPrefix} ${channel} subscribe failed:`, JSON.stringify(error));
		},
	});
}

/**
 * 连接 GoEasy
 * @returns
 */
export function onConnectGoeasy() {
	const userInfo = getUserInfo(); // 用户信息
	console.log(10, GoEasy.getConnectionStatus());
	if (!userInfo?.userId) return;
	if (GoEasy.getConnectionStatus() !== "disconnected") return;

	return new Promise((resolve, reject) => {
		GoEasy.connect({
			id: userInfo.userId,
			data: {
				nickname: userInfo.username,
				avatar: userInfo.avatar,
			},
			onSuccess: () => {
				console.log(24, "连接GoEasy成功", userInfo);
				// subscribeGroup(); // 建立连接后，订阅群聊消息，避免漏掉
				window.GRTC.on(window.GRTC.EVENT.RING, () => onRing());
				initRingListeners();
				bindPcAudioOutgoingOnce();
				subscribeCustomerMessage();
				subscribePrivateMessage(userInfo.userId);
				// 通知 UI：GoEasy 已连接，可安全绑定 GRTC 事件
				try {
					emitter.emit("goeasy:connected");
				} catch (e) {
					console.error(80, "通知 UI：GoEasy 已连接失败", e);
				}
				resolve();
			},
			onFailed: (error) => {
				console.error(28, "连接GoEasy失败", error);
				ElMessage({
					message: error.content,
					type: "error",
				});
				// 移除对this的引用，因为在回调中this是undefined
				reject(error);
			},
			onProgress: (attempts) => {
				console.log("Connecting GoEasy, attempt:", attempts);
			},
		});
	});
}

let activeCallNotification = null;
let pcCallListenersBound = false;
let pcSelfMicMuted = null;
let pcAudioOutgoingBound = false;

function closeActiveCallNotification() {
	if (activeCallNotification?.close) {
		activeCallNotification.close();
	}
	activeCallNotification = null;
}

function getSelfFromCall(call) {
	const currentUser = getUserInfo();
	if (!call || !currentUser?.userId) return null;
	if (call?.caller?.id === currentUser.userId) return call.caller;
	const self = call?.callees?.find?.((u) => u?.id === currentUser.userId);
	return self || call?.callees?.[0] || null;
}

function getCallPeerInfo(call) {
	const currentUser = getUserInfo();
	const isCaller = call?.caller?.id === currentUser?.userId;
	const peer = isCaller ? call?.callees?.[0] : call?.caller;
	const name = peer?.data?.nickname || peer?.data?.name || peer?.id || "未知用户";
	const avatar = peer?.data?.avatar || "";
	return { isCaller, name, avatar };
}

// function getCallRoute(call) {
// 	if (call?.groupId) return "/groupCall";
// 	return "/privateCall";
// }

function showPcCallNotification(call, status) {
	const { isCaller, name, avatar } = getCallPeerInfo(call);
	const isGroup = Boolean(call?.groupId);
	const isGroupAudio = isGroup && Number(call?.mediaType) === 0;
	const mediaText = call?.mediaType === 1 ? "视频" : "语音";
	const title = isGroup ? `群聊${mediaText}通话` : `${mediaText}通话`;

	const isRinging = status === "ring";
	const isIncomingRinging = isRinging && !isCaller;
	const isOutgoingRinging = isRinging && isCaller;
	const isInCall = status === "call";
	const isEnded = status === "ended";

	if (isInCall) {
		const self = getSelfFromCall(call);
		if (typeof self?.micMuted === "boolean") {
			pcSelfMicMuted = self.micMuted;
		} else if (pcSelfMicMuted == null) {
			pcSelfMicMuted = false;
		}
	} else if (isRinging) {
		pcSelfMicMuted = null;
	}

	closeActiveCallNotification();
	activeCallNotification = ElNotification({
		title,
		duration: 0,
		showClose: true,
		customClass: "grtc-call-notification",
		onClick: () => {
			if (isGroupAudio) {
				emitter.emit("grtc:pc-audio-open", { call });
			}
		},
		message: h(
			"div",
			{ class: "grtc-call-notification__body" },
			[
				h("div", { class: "grtc-call-notification__left" }, [
					avatar
						? h("img", {
								class: "grtc-call-notification__avatar",
								src: avatar,
								alt: name,
						  })
						: h("div", { class: "grtc-call-notification__avatar grtc-call-notification__avatar--empty" }),
					h("div", { class: "grtc-call-notification__meta" }, [
						h("div", { class: "grtc-call-notification__name" }, name),
						h(
							"div",
							{ class: "grtc-call-notification__status" },
							isIncomingRinging
								? "等待接听"
								: isOutgoingRinging
								? "等待对方接听"
								: isInCall
								? "接听中"
								: isEnded
								? "已挂断"
								: "状态更新中",
						),
					]),
				]),
				h("div", { class: "grtc-call-notification__actions" }, [
					isIncomingRinging
						? h(
								ElButton,
								{
									type: "danger",
									plain: true,
									onClick: () => window.GRTC?.end?.(),
								},
								() => "拒绝",
						  )
						: null,
					isInCall
						? h(
								ElButton,
								{
									type: pcSelfMicMuted ? "warning" : "success",
									plain: true,
									onClick: () => {
										const nextMuted = !pcSelfMicMuted;
										window.GRTC?.muteMic?.(nextMuted);
										pcSelfMicMuted = nextMuted;
										showPcCallNotification(
											window.GRTC?.currentCall?.() || call,
											"call",
										);
									},
								},
								() => (pcSelfMicMuted ? "开启麦克风" : "关闭麦克风"),
						  )
						: null,
					isIncomingRinging
						? h(
								ElButton,
								{
									type: "success",
									onClick: () => {
										window.GRTC
											?.accept?.()
											.then(() => {
												console.log(194, "接听")
												showPcCallNotification(call, "call");
												// router.push({ path: getCallRoute(call) });
											})
											.catch(() => {});
									},
								},
								() => "接听",
						  )
						: null,
					isOutgoingRinging
						? h(
								ElButton,
								{
									type: "danger",
									plain: true,
									onClick: () => window.GRTC?.end?.(),
								},
								() => "取消",
						  )
						: null,
					// isInCall
					// 	? h(
					// 			ElButton,
					// 			{
					// 				type: "primary",
					// 				plain: true,
					// 				onClick: () => router.push({ path: getCallRoute(call) }),
					// 			},
					// 			() => "打开通话",
					// 	  )
					// 	: null,
					isInCall
						? h(
								ElButton,
								{
									type: "danger",
									onClick: () => window.GRTC?.end?.(),
								},
								() => "挂断",
						  )
						: null,
					isGroupAudio
						? h(
								ElButton,
								{
									type: "primary",
									plain: true,
									onClick: () => emitter.emit("grtc:pc-audio-open", { call }),
								},
								() => "打开详情",
						  )
						: null,
				]),
			],
		),
	});
}

function bindPcCallListenersOnce() {
	if (pcCallListenersBound) return;
	pcCallListenersBound = true;
	const GRTC = window.GRTC;
	if (!GRTC?.on) return;

	const onUserQuit = () => {
		const call = GRTC.currentCall?.();
		if (!call) {
			closeActiveCallNotification();
			return;
		}
		// USER_QUIT 表示有人退出，不代表通话结束
		showPcCallNotification(call, "call");
	};
	const onCallEnded = () => {
		const call = GRTC.currentCall?.();
		if (!call) {
			closeActiveCallNotification();
			return;
		}
		// CALL_ENDED 才表示通话结束，通知进入结束态后自动收起
		showPcCallNotification(call, "ended");
		setTimeout(() => closeActiveCallNotification(), 2000);
	};

	const onUserMicChanged = (event) => {
		const call = GRTC.currentCall?.();
		if (!call) return;
		const self = getSelfFromCall(call);
		if (self?.id && event?.user?.id && self.id !== event.user.id) return;
		if (typeof event?.muted === "boolean") {
			pcSelfMicMuted = event.muted;
		} else if (typeof self?.micMuted === "boolean") {
			pcSelfMicMuted = self.micMuted;
		}
		showPcCallNotification(call, "call");
	};
	const onUserAccepted = () => {
		const call = GRTC.currentCall?.();
		if (!call) return;
		showPcCallNotification(call, "call");
	};

	GRTC.on(GRTC.EVENT.USER_QUIT, onUserQuit);
	GRTC.on(GRTC.EVENT.CALL_ENDED, onCallEnded);
	GRTC.on(GRTC.EVENT.USER_MIC_CHANGED, onUserMicChanged);
	GRTC.on(GRTC.EVENT.USER_ACCEPTED, onUserAccepted);
}

function bindPcAudioOutgoingOnce() {
	if (pcAudioOutgoingBound) return;
	pcAudioOutgoingBound = true;
	emitter.on("grtc:pc-audio-outgoing", (payload) => {
		const call = payload?.call || window.GRTC?.currentCall?.();
		if (!call || Number(call?.mediaType) !== 0) return;
		bindPcCallListenersOnce();
		showPcCallNotification(call, "ring");
	});
}

// 监听音视频
function onRing() {
  const currentCall = window.GRTC.currentCall();
  console.log(316, "onRing  currentCall:", currentCall)
  if (!currentCall) return

  // 先按端判断：移动端跳页，PC 再分视频弹窗/语音通知
	const mobile = isMobilePage();
	console.log(266, mobile)
  if (mobile) {
		const path = currentCall.groupId ? "/goEasy/pages/groupRing" : "/goEasy/pages/privateRing";
		router.push({ path });
		return;
  }

  // PC：视频来电直接弹 dialog
  if (Number(currentCall.mediaType) === 1) {
		closeActiveCallNotification();
		setTimeout(() => {
			emitter.emit("grtc:pc-video-ring", { call: currentCall });
			try {
				window.dispatchEvent(
					new CustomEvent("grtc:pc-video-ring", { detail: { call: currentCall } }),
				);
			} catch (e) {
				console.log("dispatch grtc:pc-video-ring failed", e);
			}
		}, 0);
		return;
  }

  // PC：语音来电使用通知（等待接听/接听中/挂断）
  bindPcCallListenersOnce();
  showPcCallNotification(currentCall, "ring");
}
/**
 * 订阅私聊消息
 */
export function subscribePrivateMessage(id) {
	// 订阅用户自身的私聊频道
	doSubscribe(
		"IM_NOTIFY_" + id,
		(message) => {
			console.log("Received 【IM_NOTIFY】 message:", message, JSON.parse(message.content));
			emitter.emit("receivedImMessage", message); // 私聊
			sendPushMessage("您收到一条新消息");
		},
		"【IM_NOTIFY】"
	);
}

/**
 * 订阅客服消息
 */
function subscribeCustomerMessage() {
	const userInfo = getUserInfo();

	// 订阅用户自身的 IM_NOTIFY 频道
	doSubscribe(
		"customer_" + userInfo.userId,
		(message) => {
			console.log("Received 【customer】 message:", message, JSON.parse(message.content));
			emitter.emit("receivedMessage", message); // 客服
			sendPushMessage("您收到一条新消息");
		},
		"【customer】"
	);
}

/**
 * 订阅群消息
 */
export function subscribeGroup(groupIds) {
	const groupIdsArr = Array.isArray(groupIds)
		? groupIds
		: typeof groupIds === "string"
		? groupIds.split(",")
		: [];

	console.log(90, groupIdsArr);
	groupIdsArr.forEach((groupId) => {
		doSubscribe(
			"IM_NOTIFY_" + groupId,
			(message) => {
				console.log(`Received 【Group: ${groupId}】 message:`, message, JSON.parse(message.content));
				emitter.emit("receivedGroupMessage", message);
				sendPushMessage("您收到一条新的群聊消息");
			},
			`【Group: ${groupId}】`
		);
	});
}

/**
 * 断开 GoEasy 连接
 * @returns
 */
export function disconnectGoeasy() {
	if (GoEasy.getConnectionStatus() !== "connected") return;
	GoEasy.disconnect({
		onSuccess: function () {
			console.log(
				140,
				" ********* GoEasy 断开连接成功！ GoEasy disconnect successfully.",
			);
		},
		onFailed: function (error) {
			console.log(
				"Failed to disconnect GoEasy, code:" +
					error.code +
					",error:" +
					error.content,
			);
		},
	});
}

/**
 * 初始化 GoEasy 音视频事件监听
 */
export function initRingListeners() {
	// // #ifdef APP-PLUS
	// if (GoEasy.getConnectionStatus() !== "disconnected") {
	// 	console.log(1777777, '监听来电事件')
	// 	GRTC.on(GRTC.EVENT.RING, onRing); //监听来电事件
	// 	ring.initAudioContext();
	// 	uni.$on("pauseRingSound", () => {
	// 		ring.pauseRingSound();
	// 	});
	// }
	// // #endif
}

/**
 * 处理来电事件
 */
// function onRing() {
	// const currentCall = GRTC.currentCall();
	// ring.playRingSound();
	// sendPushMessage("您收到一条新的来电");

	// if (currentCall.groupId) {
	// 	uni.navigateTo({
	// 		url: `/goEasy/pages/rtc/group/ring`,
	// 	});
	// } else {
	// 	uni.navigateTo({
	// 		url: `/goEasy/pages/rtc/private/ring`,
	// 	});
	// }
// }

/**
 * 发送推送消息
 * @param {*} content 
 * @returns 
 */
function sendPushMessage(content) {
	console.log(217, content);
	// return;
	// uni.createPushMessage({
	// 	content: content,
	// 	success(res) {
	// 		console.log(194, "uni.createPushMessage success", res);
	// 	},
	// 	fail(err) {
	// 		console.error(197, "uni.createPushMessage error", err);
	// 	},
	// });
}

/**
 * 更新用户信息，仅适用于音视频（有点不太灵，好友修改的信息未更新）
 * @param {*} param0 
 */
export function updateUserInfo({ avatar, username }) {
	const userInfo = getUserInfo(); // 用户信息
	axios.post("http://rest-hz.goeasy.io/v2/memberdata", {
		appkey: "BC-43a0ee269ffa4369a67711cd8a2f5a7e",
		id: userInfo.userId,
		data: {
			name: username || userInfo.username,
			avatar: avatar || userInfo.avatar,
		},
	})
}